/* eslint-disable no-undef */
import Vue from "vue";
import axios from "axios";
import getters from "./getters";
import store from "@/store";
const mutations = {
	setProducts(state, products) {
		state.products = [];
		state.categoriesProducts = [];

		if (typeof products != "undefined") {
			state.products = products.filter(p => p.instock);
			state.outOfStock = products.filter(p => !p.instock);
		}

		state.added.map(p => {
			this.commit("calculateSale", p);
			let found = state.products.find(prod => prod.id == p.id);
			if (typeof found != "undefined") {
				let indexOfFound = state.products.indexOf(found);
				state.products[indexOfFound] = p;
			}
		});
	},
	setSearch(state, search) {
		state.search = search;
	},
	setSearchResultProducts(state, products) {
		state.searchResultProducts = [];
		if (typeof products != "undefined") {
			state.searchResultProducts = products.filter(p => p.instock);
		}
	},
	setPage(state, page) {
		state.page = page;
	},
	calculateSale(state, product) {
		let sale = this.getters.getSale(product.id);

		// handle bogo sales
		if (sale && sale.hasOwnProperty('type') && (sale.type === 'qty' || sale.type === 'price')) {
			this.dispatch('applyBogoSale', sale);
		}
		// handle comax sales
		else if (sale) {
			let productsInSale = Object.values(sale.products);
			let quantityProductsInSale = 0;
			productsInSale.map(function (p) {
				let find = state.added.find((pr) => pr.id == p);
				if (typeof find != "undefined") {
					quantityProductsInSale += find.quantity;
				}
			});
			sale.quantityProductsInSale = quantityProductsInSale;
			sale.allowedMore =
				quantityProductsInSale / parseInt(sale.products_buy_quantity) < parseInt(sale.limit) &&
				quantityProductsInSale % parseInt(sale.products_buy_quantity) != 0
					? true
					: false;
			let maxQuantityAllowed = 0;
			let pricePerUnitOnSale = 0;
			let quantityCounted = 0;
			switch (sale.type) {
				case "8":
				case "5":
					// this was cacneld to make type 8 sales caclulate correctly in cart after passing sale limit qty
					// if (sale.type === '5') {
					// 	pricePerUnitOnSale = parseFloat(sale.price);
					// }
					pricePerUnitOnSale = parseFloat(sale.price);
					//console.log('sale', sale)

					//Fixed product sale price with limitation - same product
					quantityCounted = 0;
					productsInSale.map(function(p) {
						let find = state.added.find(pr => pr.id == p);
						if (typeof find != "undefined") {
							let quantityInSale = Math.min(
								Math.floor(find.quantity / parseInt(sale.products_buy_quantity)),
								parseInt(sale.limit)
							);

							let priceSet = find.price;
							if (find.oldprice) {
								priceSet = find.oldprice;
							}

							if ((find.type == "both" || find.type == "unitaskg") && find.selected == "unit") {
								priceSet = parseFloat(priceSet * find.weight);
								if (sale.type === '5') {
									pricePerUnitOnSale = parseFloat(pricePerUnitOnSale * find.weight);
								} else {
									pricePerUnitOnSale = parseFloat(parseFloat(sale.price) * find.weight);
								}
								let maxUnits = parseInt(sale.limit / find.weight);
								//if (find.quantity <= maxUnits) {
								quantityInSale = Math.min(
									Math.floor(find.quantity / parseInt(sale.products_buy_quantity)),
									parseInt(maxUnits)
								);
								//}
							}

							if (find.type == "both" && find.selected == "kg") {
								quantityInSale = Math.min(
									find.quantity / parseInt(sale.products_buy_quantity),
									parseInt(sale.limit)
								);
							}

							// console.log('CalculateSale', find);
							//
							// console.log('pricePerUnitOnSale', pricePerUnitOnSale);
							// console.log('quantityInSale', quantityInSale);
							// console.log('find.divide_by', find.divide_by);
							// console.log('find.quantity', find.quantity);
							// console.log('sale.products_buy_quantity', parseInt(sale.products_buy_quantity));
							// console.log('priceSet', priceSet);

							let totalForProduct =
								pricePerUnitOnSale * quantityInSale * find.divide_by +
								(find.quantity - quantityInSale * parseInt(sale.products_buy_quantity)) *
								priceSet *
								find.divide_by;

							// console.log('totalForProduct', totalForProduct);

							find.salePriceTotal = totalForProduct;
						}
					});
					break;
				case "6":
					//Fixed product sale price with limitation - can be from group of products
					maxQuantityAllowed = parseInt(sale.products_buy_quantity) * parseInt(sale.limit);
					quantityCounted = 0;
					quantityProductsInSale = Math.min(
						Math.floor(quantityProductsInSale / parseInt(sale.products_buy_quantity)) *
						parseInt(sale.products_buy_quantity),
						parseInt(sale.limit) * parseInt(sale.products_buy_quantity)
					);
					productsInSale.map(function(p) {
						let find = state.added.find(pr => pr.id == p);
						if (typeof find != "undefined") {
							pricePerUnitOnSale = parseFloat(sale.price / parseInt(sale.products_buy_quantity));
							let productQuantity = parseFloat(find.quantity);
							let quantityInSale = 0;
							if (quantityProductsInSale - (quantityCounted + productQuantity) >= 0) {
								quantityInSale = productQuantity;
							}
							if (quantityProductsInSale - (quantityCounted + productQuantity) < 0) {
								quantityInSale = Math.min(
									Math.max(quantityProductsInSale - quantityCounted, 0),
									productQuantity
								);
							}
							if (quantityProductsInSale == 0) {
								quantityInSale = 0;
							}
							let priceSet = find.price;
							if (find.oldprice) {
								priceSet = find.oldprice;
							}

							// fix for percentage sales
							if (!pricePerUnitOnSale && parseFloat(sale.discount_precent)) {
								pricePerUnitOnSale = parseFloat((parseFloat(find.oldprice) * ( 100 - parseFloat(sale.discount_precent) ) / 100) / parseInt(sale.products_buy_quantity));
							}

							let totalForProduct =
								pricePerUnitOnSale * quantityInSale * find.divide_by +
								(find.quantity - quantityInSale) * priceSet * find.divide_by;

							find.salePriceTotal = totalForProduct;
							quantityCounted += quantityInSale;
						}
					});
					break;
				case "7":
					maxQuantityAllowed = parseInt(sale.products_buy_quantity) * parseInt(sale.limit);
					pricePerUnitOnSale = parseFloat(sale.price / parseInt(sale.products_buy_quantity));
					quantityCounted = 0;
					sale.quantityProductsInSale = quantityProductsInSale;
					quantityProductsInSale = Math.min(
						Math.floor(quantityProductsInSale / parseInt(sale.products_buy_quantity)) *
						parseInt(sale.products_buy_quantity),
						parseInt(sale.limit) * parseInt(sale.products_buy_quantity)
					);
					sale.allowedMore = true;
					let lowestPrice = 9999;
					let lowestPriceId = false;
					let quantityInSale = 0;
					let totalQuantity = 0;
					productsInSale.map(function(p) {
						let find = state.added.find(pr => pr.id == p);
						if (typeof find != "undefined") {
							let productQuantity = parseFloat(find.quantity);

							Vue.delete(find, "giftedProduct");
							find.salePriceTotal = 0;
							totalQuantity += productQuantity;
							if (parseFloat(lowestPrice) > parseFloat(find.price)) {
								lowestPrice = find.price;
								lowestPriceId = find.id;
							}
							if (quantityProductsInSale - (quantityCounted + productQuantity) >= 0) {
								quantityInSale = productQuantity;
							}
							if (quantityProductsInSale - (quantityCounted + productQuantity) < 0) {
								quantityInSale = Math.min(
									Math.max(quantityProductsInSale - quantityCounted, 0),
									productQuantity
								);
							}
							if (quantityProductsInSale == 0) {
								quantityInSale = 0;
							}
							let priceSet = find.price;

							if (find.oldprice && find.type != "both") {
								priceSet = find.oldprice;
							}

							if ((find.type == "both" || find.type == "unitaskg") && find.selected == "unit") {
								priceSet = parseFloat(priceSet * find.weight);
								pricePerUnitOnSale = parseFloat(pricePerUnitOnSale * find.weight);
								let maxUnits = parseInt(sale.limit / find.weight);
								//if (find.quantity <= maxUnits) {
								quantityInSale = Math.min(
									Math.floor(find.quantity / parseInt(sale.products_buy_quantity)),
									parseInt(maxUnits)
								);
								//}
							}
							//let totalForProduct = pricePerUnitOnSale * quantityInSale * find.divide_by + (find.quantity - quantityInSale) * priceSet * find.divide_by;
							//find.salePriceTotal = totalForProduct;
							//sale_price_to_send = 0;
							quantityCounted += quantityInSale;
						}
					});
					let discountQuantityProduct = 0;
					// if (Math.floor(quantityProductsInSale / parseInt(sale.products_buy_quantity)) {
					discountQuantityProduct = Math.min(
						Math.trunc(totalQuantity / (parseInt(sale.products_buy_quantity) + 1)),
						parseInt(sale.limit) * parseInt(sale.products_buy_quantity)
					);

					if (lowestPriceId && discountQuantityProduct > 0) {
						let find = state.added.find(p => p.id == lowestPriceId);

						if (typeof find != "undefined") {
							let priceSet = find.price;
							let quantityToCalculate = find.quantity - discountQuantityProduct;
							if (quantityToCalculate < 0) {
								quantityToCalculate = 0;
							}
							let totalForProduct = quantityToCalculate * priceSet * find.divide_by;
							find.salePriceTotal = totalForProduct;
							Vue.set(find, "giftedProduct", discountQuantityProduct);
							find.giftedProduct = discountQuantityProduct;
							sale.used = discountQuantityProduct;
							sale.allowedMore = false;
						}
					}

					break;
			}
		}
	},
	setSales(state, sales) {
		state.sales = sales;
		state.salesproduct = JSON.parse(wpData.productssales);
	},
	setBogoSales(state, sales) {
		state.bogoSales = sales;
	},
	setCategories(state, categories) {
		state.categories = categories;
	},
	updateCart(state, { product, is_edit, onPageLoad }) {
		var update_time = new Date().toJSON();
		localStorage.setItem("last_update_time", update_time);
		/** Delivery popup */
		// if (!state.city && !state.userLogged) {
		//   this.dispatch("firstTime");

		// }

		/**
		 * Product Often popup
		 */
		var stored_cart = JSON.parse(localStorage.getItem("shopping_cart"));

		let in_cart = typeof state.added.find(p => p.id == product.id) != "undefined" ? true : false;

		if (!is_edit && !in_cart && product.often && !product.product_often) {
			Vue.prototype.$modal.show("often", { product: product });
			return;
		}

		// Grinding levels popup
		if (!is_edit && !in_cart && product.has_grinding_levels && !product.selected_grinding_level) {
			Vue.prototype.$modal.show("GrindingLevels", { product: product });
			return true;
		}

		if (!state.hideAlert) {
			state.changeInCart = true;
		}
		const perment = state.permanentproducts.find(p => p.id === product.id);
		var indexOfPermenent = state.permanentproducts.indexOf(perment);

		const cartItem = state.added.find(p => p.id === product.id);
		var indexOfCart = state.added.indexOf(cartItem);

		product.open_note = product.note;
		let round = product.quantity - Math.floor(product.quantity);
		let state_product = "";
		let category = "";
		if (Object.values(state.categoriesProducts).length > 0 && !is_edit) {
			//console.log(product);
			product.categories.map(id => {
				if (typeof state.categoriesProducts[id] != "undefined") {
					category = state.categoriesProducts[id];
				}
			});
			if (typeof category != "undefined" && category) {
				// console.log(category);
				state_product = category.find(p => p.id == product.id);
			}
			if (typeof state_product != "undefined" && state_product) {
				state_product.quantity = product.quantity;
				state_product.selected = product.selected;
			}
		}
		if (Object.values(state.categoriesProducts).length == 0 && !is_edit) {
			state_product = state.products.find(p => p.id == product.id);
			if (typeof state_product != "undefined") {
				state_product.quantity = product.quantity;
				state_product.selected = product.selected;
			}
		}

		if (product.selected == "unit") {
			product.quantity = parseInt(product.quantity);
		}
		if (product.selected == "kg") {
			if (round > 0.5) {
				product.quantity = Math.round(product.quantity);
			}
			if (round < 0.5 && round > 0) {
				product.quantity = Math.round(product.quantity) + 0.5;
			}
			if (product.quantity < 0.5) {
				product.quantity = 0;
			}
		}
		/*if (product.selected == "unit") {
      if (round > 0) {
        product.quantity = parseInt(product.quantity) + 1;
      }
    }
    if (product.selected == "kg") {
      if (round > 0.5) {
        product.quantity = Math.round(product.quantity);
      }
      if (round < 0.5) {
        product.quantity = Math.round(product.quantity)+0.5;
      }
      if(product.quantity<0.5){
        product.quantity = 0.5;
      }
    }*/

		var converted_quantity =
			product.selected == "kg" ? Math.ceil(product.quantity / product.weight) : Math.ceil(product.quantity);
		var sale_price_to_send = 0;
		let productObj = {};
		productObj.id = product.id;
		productObj.name = product.name;
		productObj.quantity = converted_quantity;
		productObj.variant = product.selected == "kg" ? "kg" : "unit";
		productObj.price =
			(product.type == "kg" || product.type == "both") && product.selected == "unit"
				? product.quantity * product.price * product.weight
				: product.selected == "kg" || product.selected == "unit"
					? product.quantity * product.price
					: product.quantity * product.price * product.weight;
		productObj.price = parseFloat(productObj.price).toFixed(2);


		if (product.quantity > 0) {
			if (!cartItem) {
				sendAddToCart(productObj);
				state.added.push(product);
				// if (state.added.length === 1) {
				// 	this.dispatch("sendCartToServer");
				// }
			} else {
				if (product.note) {
					cartItem.note = product.note;
					cartItem.open_note = product.open_note;
				}
				if (typeof stored_cart != "undefined" && stored_cart) {
					var in_cart_item = stored_cart.find(p => p.id == product.id);
					var old_quantity =
						in_cart_item.type == "kg"
							? Math.ceil(in_cart_item.qu / product.weight)
							: Math.ceil(in_cart_item.qu);
					var event_type = converted_quantity >= old_quantity ? "add" : "remove";
					var old_quantity_for_price =
						event_type == "add" ? product.quantity - in_cart_item.qu : in_cart_item.qu - product.quantity;
					// console.log('old_quantity : ' + old_quantity);
					// console.log('new_quantity : ' + product.quantity);
					// console.log('event_type : ' + event_type);

					var quantity_to_send =
						event_type == "add" ? converted_quantity - old_quantity : old_quantity - converted_quantity;
					productObj.quantity = quantity_to_send;
					var price_to_send =
						(product.type == "kg" || product.type == "both") && product.selected == "unit"
							? old_quantity_for_price * product.price * product.weight
							: product.selected == "kg" || product.selected == "unit"
								? old_quantity_for_price * product.price
								: old_quantity_for_price * product.price * product.weight;
				}

				cartItem.quantity = product.quantity;
				cartItem.selected = product.selected;
			}
		} else {
			if (indexOfCart > -1) {
				sendRemoveFromCart(productObj);
				state.added.splice(indexOfCart, 1);
				if (product.quantity == 0) {
					//store.dispatch('testCurrentSelectedVariation',[product]);
					if (indexOfPermenent > -1) {
						state.permanentproducts.splice(indexOfPermenent, 1);
					}
				}
			}
		}

		// update server cart on every cart change
		if (!onPageLoad) {
			this.dispatch("sendCartToServer");
		}

		var final_cart = [];
		for (var i in state.added) {
			final_cart.push({
				id: state.added[i].id,
				qu: state.added[i].quantity,
				note: state.added[i].note,
				type: state.added[i].selected
			});
		}

		//Get sale according to product
		let sale = this.getters.getSale(product.id);

		// bogo sales
		if (sale && sale.hasOwnProperty('type') && (sale.type === 'qty' || sale.type === 'price')) {
			//this.dispatch('applyBogoSale', sale);
			// no need fot this here, only needed in "calculateSale" function
			// need to understand why the logic for comax sales is here and in "calculateSale" function
		}
		else if (sale) {
			let productsInSale = Object.values(sale.products);
			let quantityProductsInSale = 0;
			let productsInSaleCartOrder = [];
			productsInSale.map(function(p) {
				let find = state.added.find(pr => pr.id == p);
				if (typeof find != "undefined") {
					let indexOfFind = state.added.indexOf(find);
					quantityProductsInSale += parseFloat(find.quantity);
					//productsInSaleCartOrder[indexOfFind] = find.id;
					let mod = parseFloat(find.quantity) % parseInt(sale.products_buy_quantity);
					//productsInSaleCartOrder.push({"index":indexOfFind,"mod":mod,"id":find.id});
					productsInSaleCartOrder[indexOfFind] = {
						index: indexOfFind,
						mod: mod,
						id: find.id
					};
				}
			});

			productsInSaleCartOrder.sort(function(a, b) {
				return a.mod < b.mod ? -1 : a.mod == b.mod ? 0 : 1;
				//Sort could be modified to, for example, sort on the age
				// if the name is the same.
			});
			let newOrderProducts = [];
			for (var i in productsInSaleCartOrder) {
				newOrderProducts.push(productsInSaleCartOrder[i].id);
			}
			productsInSale = newOrderProducts;
			//productsInSale = Object.values(productsInSaleCartOrder);
			let maxQuantityAllowed = 0;
			let pricePerUnitOnSale = 0;
			let quantityCounted = 0;

			switch (sale.type) {
				/** 1+1 same product */
				case "1":
					let totalForProduct;
					maxQuantityAllowed = parseInt(sale.products_buy_quantity) * parseInt(sale.limit);
					productsInSale.map(function(p) {
						let find = state.added.find(pr => pr.id == p);
						if (typeof find != "undefined") {
							if (quantityProductsInSale % 2 === 0) {
								totalForProduct =
									pricePerUnitOnSale * quantityInSale + (find.quantity - quantityInSale) * find.price;
							}
						}
					});
					find.salePriceTotal = totalForProduct;
					sale_price_to_send = totalForProduct;
					maxQuantityAllowed = Math.max(maxQuantityAllowed - find.quantity, 0);
					break;
				case "8":
				case "5":
					//Fixed product sale price with limitation - same product
					//console.log('here');
					if (sale.type === '5') {
						pricePerUnitOnSale = parseFloat(sale.price);
					}

					quantityCounted = 0;
					productsInSale.map(function(p) {
						let find = state.added.find(pr => pr.id == p);
						if (typeof find != "undefined") {
							let quantityInSale = Math.min(
								Math.floor(find.quantity / parseInt(sale.products_buy_quantity)),
								parseInt(sale.limit)
							);

							let priceSet = find.price;

							if (find.oldprice) {
								priceSet = find.oldprice;
							}

							if ((find.type == "both" || find.type == "unitaskg") && find.selected == "unit") {
								priceSet = parseFloat(priceSet * find.weight);
								if (sale.type === '5') {
									pricePerUnitOnSale = parseFloat(pricePerUnitOnSale * find.weight);
								} else {
									pricePerUnitOnSale = parseFloat(parseFloat(sale.price) * find.weight);
								}
								let maxUnits = parseInt(sale.limit / find.weight);
								//if (find.quantity <= maxUnits) {
								quantityInSale = Math.min(
									Math.floor(find.quantity / parseInt(sale.products_buy_quantity)),
									parseInt(maxUnits)
								);
								//}
							}
							if (find.type == "both" && find.selected == "kg") {
								quantityInSale = Math.min(
									find.quantity / parseInt(sale.products_buy_quantity),
									parseInt(sale.limit)
								);
							}
							let totalForProduct =
								pricePerUnitOnSale * quantityInSale * find.divide_by +
								(find.quantity - quantityInSale * parseInt(sale.products_buy_quantity)) *
								priceSet *
								find.divide_by;

							find.salePriceTotal = totalForProduct;
							sale_price_to_send = totalForProduct;
						}
					});
					break;
				case "6":
					//Fixed product sale price with limitation - can be from group of products
					maxQuantityAllowed = parseInt(sale.products_buy_quantity) * parseInt(sale.limit);

					quantityCounted = 0;
					let allQuantityProductsInSale = quantityProductsInSale;
					quantityProductsInSale = Math.min(
						Math.floor(quantityProductsInSale / parseInt(sale.products_buy_quantity)) *
						parseInt(sale.products_buy_quantity),
						parseInt(sale.limit) * parseInt(sale.products_buy_quantity)
					);
					productsInSale.map(function(p) {
						let find = state.added.find(pr => pr.id == p);
						if (typeof find != "undefined") {
							pricePerUnitOnSale = parseFloat(sale.price / parseInt(sale.products_buy_quantity));
							let productQuantity = parseFloat(find.quantity);
							/*if(allQuantityProductsInSale%parseInt(sale.products_buy_quantity)==find.quantity){
                find.salePriceTotal = 0;
                return;
              }*/
							//console.log("Product quantity - "+)

							let quantityInSale = 0;
							if (quantityProductsInSale - (quantityCounted + productQuantity) >= 0) {
								quantityInSale = productQuantity;
							}
							if (quantityProductsInSale - (quantityCounted + productQuantity) < 0) {
								quantityInSale = Math.min(
									Math.max(quantityProductsInSale - quantityCounted, 0),
									productQuantity
								);
							}
							if (quantityProductsInSale == 0) {
								quantityInSale = 0;
							}
							let priceSet = find.price;

							if (find.oldprice && find.type != "both") {
								priceSet = find.oldprice;
							}

							// fix for percentage sales
							if (!pricePerUnitOnSale && parseFloat(sale.discount_precent)) {
								pricePerUnitOnSale = parseFloat((parseFloat(find.oldprice) * ( 100 - parseFloat(sale.discount_precent) ) / 100) / parseInt(sale.products_buy_quantity));
							}

							if ((find.type == "both" || find.type == "unitaskg") && find.selected == "unit") {
								priceSet = parseFloat(priceSet * find.weight);
								pricePerUnitOnSale = parseFloat(pricePerUnitOnSale * find.weight);
								let maxUnits = parseInt(sale.limit / find.weight);
								//if (find.quantity <= maxUnits) {
								quantityInSale = Math.min(
									Math.floor(find.quantity / parseInt(sale.products_buy_quantity)),
									parseInt(maxUnits)
								);
								//}
							}
							let totalForProduct =
								pricePerUnitOnSale * quantityInSale * find.divide_by +
								(find.quantity - quantityInSale) * priceSet * find.divide_by;
							find.salePriceTotal = totalForProduct;
							sale_price_to_send = totalForProduct;
							quantityCounted += quantityInSale;
						}
					});
					break;
				/** 3+1 same product */
				case "7":
					maxQuantityAllowed = parseInt(sale.products_buy_quantity) * parseInt(sale.limit);
					pricePerUnitOnSale = parseFloat(sale.price / parseInt(sale.products_buy_quantity));
					quantityCounted = 0;
					allQuantityProductsInSale = quantityProductsInSale;
					quantityProductsInSale = Math.min(
						Math.floor(quantityProductsInSale / parseInt(sale.products_buy_quantity)) *
						parseInt(sale.products_buy_quantity),
						parseInt(sale.limit) * parseInt(sale.products_buy_quantity)
					);
					sale.allowedMore = true;

					let lowestPrice = 9999;
					let lowestPriceId = false;
					let quantityInSale = 0;
					let totalQuantity = 0;

					productsInSale.map(function(p) {
						let find = state.added.find(pr => pr.id == p);
						if (typeof find != "undefined") {
							let productQuantity = parseFloat(find.quantity);
							Vue.delete(find, "giftedProduct");
							find.salePriceTotal = 0;
							totalQuantity += productQuantity;
							if (parseFloat(lowestPrice) > parseFloat(find.price)) {
								lowestPrice = find.price;
								lowestPriceId = find.id;
							}

							if (quantityProductsInSale - (quantityCounted + productQuantity) >= 0) {
								quantityInSale = productQuantity;
							}
							if (quantityProductsInSale - (quantityCounted + productQuantity) < 0) {
								quantityInSale = Math.min(
									Math.max(quantityProductsInSale - quantityCounted, 0),
									productQuantity
								);
							}
							if (quantityProductsInSale == 0) {
								quantityInSale = 0;
							}
							let priceSet = find.price;

							if (find.oldprice && find.type != "both") {
								priceSet = find.oldprice;
							}

							if ((find.type == "both" || find.type == "unitaskg") && find.selected == "unit") {
								priceSet = parseFloat(priceSet * find.weight);
								pricePerUnitOnSale = parseFloat(pricePerUnitOnSale * find.weight);
								let maxUnits = parseInt(sale.limit / find.weight);
								//if (find.quantity <= maxUnits) {
								quantityInSale = Math.min(
									Math.floor(find.quantity / parseInt(sale.products_buy_quantity)),
									parseInt(maxUnits)
								);
								//}
							}
							//let totalForProduct = pricePerUnitOnSale * quantityInSale * find.divide_by + (find.quantity - quantityInSale) * priceSet * find.divide_by;
							//find.salePriceTotal = totalForProduct;
							sale_price_to_send = 0;
							quantityCounted += quantityInSale;
						}
					});
					let discountQuantityProduct = 0;
					// if (Math.floor(quantityProductsInSale / parseInt(sale.products_buy_quantity)) {
					discountQuantityProduct = Math.min(
						Math.trunc(totalQuantity / (parseInt(sale.products_buy_quantity) + 1)),
						parseInt(sale.limit) * parseInt(sale.products_buy_quantity)
					);

					if (lowestPriceId && discountQuantityProduct > 0) {
						let find = state.added.find(p => p.id == lowestPriceId);
						if (typeof find != "undefined") {
							let priceSet = find.price;
							let quantityToCalculate = find.quantity - discountQuantityProduct;
							if (quantityToCalculate < 0) {
								quantityToCalculate = 0;
							}
							let totalForProduct = quantityToCalculate * priceSet * find.divide_by;
							find.salePriceTotal = totalForProduct;
							Vue.set(find, "giftedProduct", discountQuantityProduct);
							find.giftedProduct = discountQuantityProduct;
							sale_price_to_send = totalForProduct;
							sale.used = discountQuantityProduct;
							sale.allowedMore = false;
						}
					}

					break;
			}

			//console.log(quantityProductsInSale);
		}

		productObj.price =
			sale_price_to_send > 0
				? parseFloat(sale_price_to_send / product.quantity).toFixed(2)
				: parseFloat(price_to_send).toFixed(2);
		switch (event_type) {
			case "add":
				sendAddToCart(productObj);
				break;
			case "remove":
				sendRemoveFromCart(productObj);
				break;
		}

		setTimeout(() => {
			state.changeInCart = false;
		}, 3000);

		this.commit("calculateSale", product);

		// send cart to recipes ai bot
		//this.dispatch("recipes_ai");

		// clear search
		setTimeout(function(){
			$('input#search').val('');
		}, 100);

		//state.cart = final_cart;
		localStorage.setItem("shopping_cart", JSON.stringify(final_cart));
		localStorage.setItem("full_cart", JSON.stringify(state.added));
		return;
	},

	clearCart(state) {
		state.showCartRecoveredNotice = false;
		if (state.products.length > 0) {
			for (var i in state.products) {
				state.products[i].quantity = 0;
				//store.dispatch('testCurrentSelectedVariation',[product]);
			}
		}
		if (Object.values(state.categoriesProducts)) {
			let all_prods = Object.values(state.categoriesProducts);
			all_prods.map(cat => {
				cat.forEach(p => {
					p.quantity = 0;
				});
			});
		}
		state.added = [];
		state.orderAs = false;
		state.orderEdit = false;
		state.orderEditMeta = false;
		state.createPermenantOrder = false;
		//state.permanentproducts = [];
		localStorage.removeItem("shopping_cart");
		localStorage.removeItem("perment_orders");
		localStorage.removeItem("full_cart");
		localStorage.removeItem("carmella-orderedit");
		localStorage.removeItem("carmella-orderEditMeta");
		localStorage.removeItem("carmella-per_order");
		localStorage.removeItem("carmella-PermenantOrderEdit");
		localStorage.removeItem("carmella-orderedit_time");
		this.commit('resetBuymeCards');
		closeCartBG();
		// if ($("#scrollbar1").length > 0) {
		//   setTimeout(function () {
		//     var $scrollbar = $("#scrollbar1");
		//     var scrollbar = $scrollbar.data("plugin_tinyscrollbar");
		//     scrollbar.update("relative");
		//   }, 100);
		// }
		this.dispatch("sendCartToServer");
		return;
	},
	setPerEdit(state, order) {
		if (typeof order != "undefined" && order) {
			state.permenantOrderEdit = order;
			localStorage.setItem("carmella-PermenantOrderEdit", JSON.stringify(state.permenantOrderEdit));
		} else {
			state.permenantOrderEdit = false;
			localStorage.removeItem("carmella-PermenantOrderEdit");
		}
	},
	selectShippingType(state) {
		$.ajax({
			type: "POST",
			url: ajaxUrl,
			data: {
				action: "select_shipping_type",
				shipping_type: state.orderType
			},
			dataType: "json",
			success: function(htmlResponse) {
				//	addProductToCartCallbackWoo(htmlResponse.fragments,productId);
			}
		});
	},
	setProductPop(state, product) {
		let state_product = "";
		let category = "";
		if (Object.values(state.categoriesProducts).length > 0) {
			product.categories.map(id => {
				if (typeof state.categoriesProducts[id] != "undefined") {
					category = state.categoriesProducts[id];
				}
			});
			if (typeof category != "undefined") {
				category = Object.values(category);
				state_product = category.find(p => p.id == product.id);
			}
		} else {
			state_product = state.products.find(p => p.id == product.id);
		}
		if (typeof state_product != "undefined" && state_product) {
			product.quantity = state_product.quantity;
			product.selected = state_product.selected;
		}
		state.ProductPop = product;
		state.showProductPop = true;
	},
	ClearProductPop(state) {
		state.ProductPop = "";
		state.showProductPop = false;
	},
	changeCheckoutStage(state, change) {
		const product_for_google = getters.cartForGoogle(state);

		localStorage.setItem("google_cart", JSON.stringify(product_for_google));

		var step = 0;
		if (change == "info") {
			step = 1;

			sendCheckoutStep(product_for_google, step, "Billing");
		}
		if (change == "shippment") {
			step = 2;
			sendCheckoutStep(product_for_google, step, "Shipment");
		}
		if (change == "payment") {
			step = 3;
			sendCheckoutStep(product_for_google, step, "Payment");
		}
		state.checkoutStage = change;
	},
	toggleChangeInCart(state) {
		if (state.changeInCart) {
			state.changeInCart = false;
		} else {
			state.changeInCart = true;
		}
	},
	setUserCheckoutInfo(state, user) {
		state.userCheckoutInfo = user;
		state.allowPermOrder = user.allowed_perm;
	},
	setUserInfo(state, user) {
		state.userLoggedInfo = user;
		state.userLogged = true;
		state.isAdmin = user.isAdmin;
		if (user.next_order_coupon) {
			state.coupon = user.next_order_coupon;
		} else if (state.coupon) {
			state.coupon = state.coupon;
		} else {
			state.coupon = "";
		}
		if (typeof sendFlashyEvent == "function") {
			sendFlashyEvent(user);
		}

		state.allowPermOrder = user.allowed_perm;
		//state.storedFavs = [...user.favoriteProducts];
		// state.storedFavs = user.favoriteProducts.map((v,i)=>{
		// 	return v['id'];
		// });

		if (typeof user.favoriteProducts === "object" && user.favoriteProducts !== null) {
			user.favoriteProducts = Object.values(user.favoriteProducts);
		}
		state.storedFavs = user.favoriteProducts;
		this.commit("setPermOrder", user.permanent_order);

		localStorage.setItem("user_info", JSON.stringify(user));
	},
	clearUser(state) {
		state.userLoggedInfo = "";
		state.userLogged = false;
		localStorage.removeItem("user_info");
		this.commit('resetBuymeCards');
	},
	setPermenant(state, product) {
		if (typeof product != "object") {
			return;
		}
		let find = state.permanentproducts.find(p => p.id == product.id);
		if (typeof find == "undefined") {
			state.permanentproducts.push(product);
			localStorage.setItem("perment_orders", JSON.stringify(state.permanentproducts));
		}
	},
	removePermenant(state, indexToRemove) {
		state.permanentproducts.splice(indexToRemove, 1);
		localStorage.setItem("perment_orders", JSON.stringify(state.permanentproducts));
	},
	clearPermenant(state) {
		state.permanentproducts = [];
		localStorage.setItem("perment_orders", JSON.stringify(state.permanentproducts));
	},
	setFormFields(state, data) {
		state.formFields[data.name] = data.value;
	},
	clearFormFields(state) {
		state.formFields = {};
	},
	setCity(state, city) {
		state.city = city;
		localStorage.setItem("city", JSON.stringify(city));
	},
	setCoupon(state, coupon) {
		state.coupon = coupon;
	},
	sentCart(state, bool) {
		state.sentCart = bool;
	},
	sendingCart(state, data) {
		state.sendingCart = data;
	},
	sendingCartToRecipeBot(state, data) {
		state.sendingCartToRecipeBot = data;
	},
	setTmpUser(state, user) {
		state.tmpUser = user;
	},
	swapUsers(state) {
		let tmp = state.tmpUser;
		state.tmpUser = state.userLoggedInfo;
		state.userLoggedInfo = tmp;
	},
	initOrderAs(state) {
		state.orderAs = false;
		localStorage.removeItem("carmella-orderas");
	},
	setOrderAs(state, user) {
		state.orderAs = user;
		localStorage.setItem("carmella-orderas", JSON.stringify(state.orderAs));
	},
	setCities(state, cities) {
		state.cities = cities;
		localStorage.setItem("carmella-cities", JSON.stringify(state.cities));
	},
	setShipSlots(state, slots) {
		state.shipSlots = slots;
	},
	setPaymentForm(state, form) {
		state.paymentIframe = form;
		localStorage.setItem("carmella-payform", JSON.stringify(state.paymentIframe));
	},
	clearPaymentForm(state) {
		state.paymentIframe = "";
		localStorage.removeItem("carmella-payform");
	},
	setOrderMeta(state, payload) {
		state.orderEditMeta = payload;
		localStorage.setItem("carmella-orderEditMeta", JSON.stringify(state.orderEditMeta));
	},
	setOrderEdit(state, docNumber) {
		if (docNumber) {
			state.orderEdit = docNumber;
			localStorage.setItem("carmella-orderedit", JSON.stringify(state.orderEdit));
			let time = new Date().toISOString();
			localStorage.setItem("carmella-orderedit_time", time);
			return;
		}
		localStorage.removeItem("carmella-orderedit");
		localStorage.removeItem("carmella-orderedit_time");
		state.orderEdit = false;
		state.orderEditMeta = "";
		//this.dispatch('clarCart');
		//Vue.prototype.$modal.show('timeup');
	},
	setLocalPickup(state, payload) {
		state.localPickup = payload;
	},
	setStartProduct(state, product) {
		state.startProduct = product;
		state.ProductPop = product;
		state.showProductPop = true;
	},
	setStartCategory(state, category) {
		state.startCategory = category;
	},
	setLastUpdate(state, time) {
		state.lastUpdate = time;
	},
	setCategoriesProducts(state, array) {
		state.products = [];
		state.categoriesProducts = array;
	},
	setHasOrderEdit(state, flag) {
		state.hasOrderEdit = flag;
		localStorage.setItem("carmella-hasEdit", state.hasOrderEdit);
	},
	setPremenantOrder(state, flag) {
		if (flag == "true") flag = true;
		if (flag == "false") flag = false;
		state.createPermenantOrder = flag;
		localStorage.setItem("carmella-per_order", state.createPermenantOrder);
	},
	setPermOrder(state, order) {
		if (typeof order == "object") {
			state.permOrder = order;
		} else {
			state.permOrder = false;
		}

		state.permOrderLoaded = true;
	},
	setPermOrderNew(state, status) {
		state.permOrderNew = status;
	},
	setPermOrderEdit(state, status) {
		state.permOrderEdit = status;
	},
	hideAlert(state, status) {
		state.hideAlert = status;
	},
	checkoutUserExists(state, status) {
		state.checkoutUserExists = status;
	},
	cartTotal(state, total) {
		state.cartTotal = total;
	},
	toggleProductFilter(state, filterName) {
		const filters = state.productFilters;
		const index = filters.findIndex(filter => filter.name === filterName);
		filters[index].isActive = !filters[index].isActive;
		if (filters[index].isActive) {
			return true;
		} else {
			return false;
		}
	},
	clearProductFilters(state) {
		state.productFilters.forEach(filter => {
			filter.isActive = false;
		});
	},
	setInApp(state, bool) {
		state.inApp = bool;
	},
	setWeightAndQuantityShown(state) {
		state.weightAndQuantityPopupShown = true;
		localStorage.setItem("carmella-weightAndQuantityPopupShown", "1");
	},
	setCoordinates(state, coordinates) {
		state.coordinates = coordinates;
	},
	useCashbackPoints(state, points) {
		state.cashback.process.pointsUsed = points;
		state.cashback.process.pointsTotal -= points;
		localStorage.setItem('cashback_points_used', points);
	},
	resetUsedCashbackPoints(state) {
		state.cashback.process.pointsUsed = 0;
		state.cashback.process.pointsTotal = state.cashback.points;
		localStorage.removeItem('cashback_points_used');
	},
	setGiftcard(state, giftcard) {
		state.giftcard = giftcard;
	},
	setGiftCardPurchaseSelectedCards(state, giftcards) {
		giftcards = giftcards.filter(item => item.quantity > 0).map(item => ({
			...item,
			restored: false,
			send_details: {
				method: "their_mail",
				name: "",
				email: "",
				phone: "",
				message: ""
			}
		}));
		state.giftCardPurchaseSelectedCards = giftcards;
	},
	setEmergencyMode(state, payload) {
		state.emergencyMode = payload;
	},
	setProductsView(state, payload) {
		localStorage.setItem("products_view", payload);
		state.productsView = payload;
	},
	addBuymeCard(state, card) {
		state.buymeCards.push(card);
		localStorage.setItem("buyme_cards", JSON.stringify(state.buymeCards));
	},
	removeBuymeCard(state, index) {
		state.buymeCards.splice(index, 1);
		localStorage.setItem("buyme_cards", JSON.stringify(state.buymeCards));
	},
	resetBuymeCards(state) {
		localStorage.removeItem('buyme_cards');
	}
};

export default mutations;
